import React from 'react';

const Edit = ({ className }) => (
  <svg
    className={className}
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4046 3.99339C13.8433 3.55469 14.0898 2.95969 14.0898 2.33927C14.0898 1.71886 13.8433 1.12386 13.4046 0.685158C12.9659 0.246459 12.3709 0 11.7505 0C11.1301 0 10.5351 0.246459 10.0964 0.685158L9.27588 1.50622L12.5835 4.81387L13.4046 3.99339Z"
      fill="white"
      fillOpacity="0.5"
    />
    <path
      d="M11.7563 5.64078L4.76496 12.6333C4.39018 13.008 3.92062 13.2738 3.40646 13.4023L0.72689 14.0725C0.628887 14.097 0.526195 14.0958 0.428825 14.0688C0.331454 14.0419 0.242725 13.9902 0.171285 13.9187C0.0998454 13.8473 0.0481322 13.7585 0.0211852 13.6612C-0.0057618 13.5638 -0.00702343 13.4611 0.0175235 13.3631L0.687708 10.6835C0.816199 10.1694 1.08201 9.69981 1.45673 9.32504L8.44805 2.33313L11.7563 5.64136V5.64078Z"
      fill="white"
      fillOpacity="0.5"
    />
  </svg>
);

export default Edit;
